import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types";

export const TemplateFieldMetaIO = t.type({
    name: t.string,
    alternativeName: t.union([t.string, t.null, t.undefined]),
    defaultValue: t.union([t.string, t.null, t.undefined]),
});

export const QrOriginIO = t.union([
    t.literal("bottom-left"),
    t.literal("top-left"),
    t.literal("top-right"),
    t.literal("bottom-right"),
]);

export const QrCoordinatesPositionIO = t.type({
    type: t.literal("coordinates"),
    page: t.number,
    x: t.number,
    y: t.number,
    origin: QrOriginIO,
});

export const QrPositionIO = QrCoordinatesPositionIO;

export const QrSizeIO = t.number;

export const QrCodeSpecIO = t.type({
    id: t.string,
    content: t.string,
    position: QrPositionIO,
    size: QrSizeIO,
    color: t.string,
    backgroundColor: t.string,
});

export const TemplateMetaIO = t.type({
    id: t.string,
    name: t.string,
    fields: t.array(TemplateFieldMetaIO),
    qrCodes: t.array(QrCodeSpecIO),
    updatedAt: t.union([DateFromISOString, t.null, t.undefined]),
});

export type TemplateFieldMeta = t.TypeOf<typeof TemplateFieldMetaIO>;
export type QrOrigin = t.TypeOf<typeof QrOriginIO>;
export type QrCoordinatesPosition = t.TypeOf<typeof QrCoordinatesPositionIO>;
export type QrPosition = t.TypeOf<typeof QrPositionIO>;
export type QrSize = t.TypeOf<typeof QrSizeIO>;
export type QrCodeSpec = t.TypeOf<typeof QrCodeSpecIO>;
export type TemplateMeta = t.TypeOf<typeof TemplateMetaIO>;
